import React, { Component } from 'react';
import { Popover, Col, Modal, Icon, Button, Checkbox, Radio, Transfer, Select, Row, Input, Tag } from 'antd';
import { proxy } from '../../helpers/util';
import Adddefineditem from './addDefineditem'
let Table = null;
export default class FilterDefined extends React.Component {
  constructor(props) {
    super(props);
    Table = require('../basic/table').default;
    this.state = {
      visible: true,
      addVisible: false,
      dataSource: [],
      editdata: {}
    }
  }
  componentDidMount() {
    let { filterId } = this.props;
    let columns = {
      cCaption: { cItemName: 'itemTitle', cShowCaption: '过滤项名称', iColWidth: 150, bHidden: false, bShowIt: true, bCanModify: false, cControlType: 'Input', bMustSelect: true },
      cCycle: { cItemName: 'comparelogicName', cShowCaption: '比较符', iColWidth: 200, bHidden: false, bShowIt: true, bCanModify: false, cControlType: 'Input', bMustSelect: true },
      cStart: { cItemName: 'itemTypeName', cShowCaption: '过滤类型', iColWidth: 150, bHidden: false, bShowIt: true, bCanModify: false, cControlType: 'Input', bMustSelect: true },
    };
    this.gridModel = new cb.models.GridModel({
      columns: columns,
      independent: true,
      readOnly: false,
      showRowNo: true,
      showCheckBox: false,
      showAggregates: false,
      pagination: false,
      isDirty: true,
      showColumnSetting: false,
    });
    this.showGridmodel(filterId)
  }
  async  showGridmodel(filterId) {
    const config = {
      url: 'filterDesign/getCustMetaFilterItems',
      method: 'GET',
      params: {
        filtersId: filterId
      }
    };
    const json = await proxy(config);
    if (json.code !== 200) return
    let newdata = [];
    json.data.forEach(function (ele, index) {
      let item = {
        'itemTitle': ele.itemTitle,
        'comparelogicName': ele.comparelogicName,
        'itemTypeName': ele.itemTypeName
      }
      newdata.push(item)
    })
    this.gridModel.setDataSource(newdata);
    json.data && this.setState({ dataSource: json.data })
  }
  reshowGridmodel = (filterId) => {
    let self = this;
    self.showGridmodel(filterId)
  }
  onCancel = (e) => {
    this.setState({ visible: !this.state.visible })
  }
  addFilteritem() {
    const action = {
      "cControlType": "Toolbar",
      "cStyle": "{\"fixedwidth\":150}",
      "controls":
        [
          {
            "cItemName": "btnEditRow", "cCaption": "编辑", "iOrder": 34, "cShowCaption": "编辑", "iStyle": 0,
            "cControlType": "button", "icon": "shanchu1", "childrenField": "purInRecords", "key": "3876626"
          },
          {
            "cItemName": "btnDeleteRow", "cCaption": "删除", "iOrder": 34, "cShowCaption": "删除", "iStyle": 0,
            "cControlType": "button", "icon": "shanchu1", "childrenField": "purInRecords", "key": "3876626"
          }
        ]
    }
    return (<div>
      <div className="filterdefined_addbutton" style={{ width: 50, marginLeft: 720, marginTop: -50 }}>
        <div className="add_button">
          <Button type='primary' onClick={() => this.definedItem()}>新增</Button>
        </div>
      </div>
      <Table action={action} onActionClick={this.onActionClick} noViewModel={true} width={800} height={441} model={this.gridModel} />
    </div>)
  }
  onActionClick = (index, action) => {
    let { dataSource } = this.state;
    let id = dataSource[index].id;
    const { cItemName } = action;
    if (cItemName == 'btnDeleteRow') {
      cb.utils.confirm("确定删除此过滤项么？", () => {
        this.deleteRow(id)
      })
    }
    else {
      this.editRow(id)
    }
  }
  async editRow(id) {
    let { filterId } = this.props;
    const config = {
      url: 'filterDesign/getCustMetaFilterItemById',
      method: 'GET',
      params: {
        itemId: id
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('编辑打开失败!' + json.message, 'error')
      return;
    }
    this.showGridmodel(filterId);
    this.setState({ editdata: json.data, addVisible: true })
  }
  async deleteRow(id) {
    let { filterId,modelId } = this.props;
    const config = {
      url: 'filterDesign/delCustMetaFilterItem',
      method: 'GET',
      params: {
        itemId: id
      }
    }
    const json = await proxy(config);
    if (json.code !== 200) {
      cb.utils.alert('操作失败!' + json.message, 'error');
      return;
    }
    cb.utils.alert("操作成功！", 'success');
    this.showGridmodel(filterId)
    this.props.regetquery(modelId,filterId)
  }
  definedItem() {
    this.setState({ addVisible: true, editdata: {} })
  }
  closeadd = () => {
    this.setState({ addVisible: false })
  }
  render() {
    let addFilteritem = this.addFilteritem();
    let { addVisible } = this.state;
    let addFilterdefined = addVisible ? <Adddefineditem modelId={this.props.modelId}  regetquery={ this.props.regetquery} showGrid={this.reshowGridmodel} closeadd={this.closeadd} filtersId={this.props.filterId} model={this.props.model} editdata={this.state.editdata} /> : '';
    return (
      <div className="defined_modal">
        <Modal title="自定义过滤条件列表" visible={this.state.visible} width="820px" className="filter_defined_list"
          onOk={() => this.onCancel()} onCancel={() => this.onCancel()} maskClosable={false}>
          <div>{addFilteritem}</div>
          {addFilterdefined}
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/filter/filterDefined.jsx